import { Add } from "@mui/icons-material";

import { Button } from "@features/ui";

import useAddRestockOrdersMutation from "../data/mutations/useAddRestockOrders";

const DistRestockOptions = () => {
  const addRestockOrdersMutation = useAddRestockOrdersMutation();
  const addRestockOrder = (isBrandFunded: boolean) => {
    addRestockOrdersMutation.mutate([{ isBrandFunded }]);
  };
  return (
    <div className="space-y-4">
      <Button
        fullWidth
        variant="outlined"
        startIcon={<Add />}
        onClick={() => addRestockOrder(false)}
        loading={addRestockOrdersMutation.isPending}
      >
        Add Restock Order
      </Button>
      <Button
        fullWidth
        variant="outlined"
        startIcon={<Add />}
        onClick={() => addRestockOrder(true)}
        loading={addRestockOrdersMutation.isPending}
      >
        Add Brand-Funded Restock Order
      </Button>
    </div>
  );
};

export default DistRestockOptions;
